import { FlexAlignCenter } from 'components/primitives/flex';
import { atom, useAtomValue } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import dayjs from 'dayjs';
import { FilterButtonWithMobileDrawer } from 'components/search/v2/Filter/FilterButtonWithMobileDrawer';
import useMediaQuerySafe from 'hooks/useMediaQuerySafe';
import { breakpoints } from 'components/search/v2/styleConstants';
import { getMaxQueryWidth } from 'helpers/breakpoints';
import { CustomFilterButtonProps } from '../FilterButton';
import {
  durationHoursAtom,
  durationHoursTempAtom,
  durationHoursManipulatorAtom,
  isMultiDayBookingAtom,
  multiDayEndDateAtom,
  multiDayStartDateAtom,
} from '../filterStore';
import { getAtomCheckboxObject } from '../atomUtils';
import { duplicateCheckboxAtomArrayAtom } from '../filterAtomUtils';
import DurationFilterContent, { DurationFilterContentWithTempAtom } from './DurationFilterContent';

const isActiveAtom = atom((get) => get(isMultiDayBookingAtom) || get(durationHoursManipulatorAtom).length > 0);

export default function DurationFilterButton(props: CustomFilterButtonProps) {
  const { toggleFilterDropdown, name } = props;
  const duration = useAtomValue(durationHoursManipulatorAtom);
  const isMultiday = useAtomValue(isMultiDayBookingAtom);
  const startDate = useAtomValue(multiDayStartDateAtom);
  const endDate = useAtomValue(multiDayEndDateAtom);
  const isMobile = useMediaQuerySafe(getMaxQueryWidth(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX));

  const getLabel = () => {
    if (isMultiday) return `${dayjs(endDate).diff(startDate, 'day') + 1} days`;
    return duration.length === 1 ? duration[0] : 'Duration';
  };

  const onClear = useAtomCallback((get, set) => {
    const durations = get(durationHoursTempAtom);
    set(
      durationHoursTempAtom,
      durations.map((d) => getAtomCheckboxObject(d.value, d.label, false))
    );
  });

  const onShowResults = useAtomCallback((get, set) => {
    const newDurationsAtom = duplicateCheckboxAtomArrayAtom(durationHoursTempAtom);
    set(durationHoursAtom, get(newDurationsAtom));
    toggleFilterDropdown(null);
  });

  return (
    <FilterButtonWithMobileDrawer
      {...props}
      name={name}
      title="Duration"
      label={<FlexAlignCenter gap="8px">{getLabel()}</FlexAlignCenter>}
      content={isMobile ? <DurationFilterContentWithTempAtom /> : <DurationFilterContent />}
      onClear={onClear}
      onShowResults={onShowResults}
      isFilterActiveAtom={isActiveAtom}
      toggleDropdown={toggleFilterDropdown}
      disabled={isMultiday}
    />
  );
}
